// extracted by mini-css-extract-plugin
module.exports = {"section":"SmartHomePanel3_section__FdlfM"};